export default {
  initialLevel: 'Initial Level',
  finalLevel: 'Final Level',
  initialLevelError: 'Initial level must not be greater than final level',
  finalLevelError: 'Final level must not be less than initial level',
  pedagogicalHoursTotal: 'Total pedagogical hours',
  totalHours: 'Total Hours',
  automatic: 'Automatic',
  planned: 'Planned',
  credit: 'Credit',
  greaterThanOrEqualToZeroError: 'This field must be greater than or equal to zero.',
  elective: 'electives',
  noElectiveMatters: 'There are no {entity} electives.',
}
